import { decoItemMasterRecords } from "./records/material-item-master-records";
import IMaterialItemMaster from "../interfaces/masters/material-item-master-interface";

class MaterialItemMaster implements IMaterialItemMaster {
  id: String;
  name: String;
  code: String;

  constructor(record: IMaterialItemMaster) {
    this.id = record.id;
    this.name = record.name;
    this.code = record.code;
  }

  /**
   * レコード取得
   */
  public static records: IMaterialItemMaster[] = decoItemMasterRecords;
}

export default MaterialItemMaster;
